import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./locales/it.json";
import italianCopy from "./copy/it.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import birthdayBonus from "./birthdayBonus";
import { storedPreference } from "./preference";

const translation = (language, existing) => ({...existing, birthdayBonus:birthdayBonus[language],
  bonusKinds:{...existing.bonusKinds, birthday:birthdayBonus[language].birthday}});

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: translation('it', it), copy: italianCopy },
    en: { translation: translation('en', en) },
    es: { translation: translation('es', es) },
    fr: { translation: translation('fr', fr) },
    de: { translation: translation('de', de) },
  },
  lng: "it",
  fallbackLng: "it",
  supportedLngs: ["it", "en", "es", "fr", "de"],
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") document.documentElement.lang = "it";
export const storedLanguage = storedPreference();
export default i18n;

